import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrlApi } from "../../proxy";
import axios, { AxiosResponse } from "axios";

export const toGetPartners = createAsyncThunk<AxiosResponse<any, any>, any>(
  "partners/toGetPartners",
  async (lang) => {
    try {
      const response = await axios.get(
        `${baseUrlApi}portal/partners?lang=${lang}`
      );
      return response;
    } catch (error) {
      throw error;
    }
  }
);
